import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchHistory } from 'actions/mypage/history';
import { downloadReceipt } from 'actions/mypage/receipt';
import { showAlert } from 'actions/common/alert';
import { push } from 'connected-react-router';
import History from 'components/Mypage/History';

const mapStateToProps = ({
  mypageHistory: { headerInfo, orderInfo, deliveryInfo, error },
  mypageReceipt: { url }
}) => ({
  headerInfo,
  orderInfo,
  deliveryInfo,
  error,
  receiptURL: url
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchHistory,
      downloadReceipt,
      push,
      showAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(History);



// WEBPACK FOOTER //
// ./src/containers/Mypage/History/index.js